module.exports = __webpack_public_path__ + "files/fe59d80b5cb2e94b07e739dd215a3f74.png";